import Notifikasi from './Notifikasi';
import HasilVerval from './HasilVerval';
import HasilSupervisi from './HasilSupervisi';
import DetailHasilSupervisi from './DetailHasilSupervisi';

export const NotifikasiConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/Notifikasi',
            component: Notifikasi
        }
        ,{
            path     : '/HasilVerval',
            component: HasilVerval
        }
        ,{
            path     : '/HasilSupervisi',
            component: HasilSupervisi
        }
        ,{
            path     : '/DetailHasilSupervisi/:supervisi_pengawas_id',
            component: DetailHasilSupervisi
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/Notifikasi/NotifikasiConfig.js